import { Button } from '@/components/ui/button';

interface Reward {
  target: number;
  prize: string;
  description: string;
  image: string;
  id: string | null;
  achieved: boolean;
  releaseDate?: Date;
}

interface RewardsSectionProps {
  rewards: Reward[];
  referralCounts: { active: number; pending: number };
  deliveryStatus: Record<string, { submitted: boolean; submittedAt: number | null }>;
}

export const RewardsSection = ({ rewards, referralCounts, deliveryStatus }: RewardsSectionProps) => {
  return (
    <div className="bg-white dark:bg-gray-800 shadow-sm rounded-lg p-6">
      <h3 className="text-2xl font-bold dark:text-white mb-2">Progresso de Recompensas</h3>
      <p className="text-gray-600 dark:text-gray-400 mb-6">
        Seu progresso em cada recompensa.
      </p>
      
      <div className="space-y-6">
        {rewards.map((reward) => (
          <div key={reward.target} className="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-sm">
            <div className="flex gap-4">
              <img 
                src={reward.image} 
                alt={reward.prize} 
                className="w-24 h-24 object-cover rounded-lg"
              />
              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <h4 className="text-lg font-semibold dark:text-white">{reward.prize}</h4>
                  {reward.id && (
                    <div className="ml-2">
                      {reward.achieved ? (
                        deliveryStatus[reward.id]?.submitted ? (
                          <Button
                            disabled
                            size="sm"
                            variant="outline"
                            className="text-xs bg-gray-100 text-gray-500 cursor-not-allowed border-gray-200"
                          >
                            Resgatado
                          </Button>
                        ) : reward.prize === "em breve." ? (
                          reward.releaseDate && reward.releaseDate > new Date() ? (
                            <Button
                              disabled
                              size="sm"
                              variant="outline"
                              className="text-xs bg-gray-100 text-gray-500 cursor-not-allowed border-gray-200"
                            >
                              Aguardando
                            </Button>
                          ) : (
                            <Button
                              size="sm"
                              onClick={() => window.location.href = `/delivery?product=${reward.id}`}
                              className="text-xs bg-[#FFB800] hover:bg-[#FFA500] text-black transition-all duration-300"
                            >
                              Resgatar
                            </Button>
                          )
                        ) : (
                          <Button
                            size="sm"
                            onClick={() => window.location.href = `/delivery?product=${reward.id}`}
                            className="text-xs bg-[#FFB800] hover:bg-[#FFA500] text-black transition-all duration-300"
                          >
                            Resgatar
                          </Button>
                        )
                      ) : (
                        <Button
                          disabled
                          size="sm"
                          variant="outline"
                          className="text-xs bg-gray-100 text-gray-500 cursor-not-allowed border-gray-200"
                        >
                          Faltam {reward.target - referralCounts.active}
                        </Button>
                      )}
                    </div>
                  )}
                </div>
                <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
                  {reward.description}
                </p>
                
                <div className="relative">
                  <div className="h-2 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-[#FFB800] transition-all duration-500"
                      style={{ 
                        width: `${Math.min(100, (referralCounts.active) / reward.target * 100)}%`
                      }}
                    />
                  </div>
                  <div className="absolute right-0 top-[-20px] text-sm font-medium dark:text-gray-200">
                    {referralCounts.active}/{reward.target}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};